import { Navigate } from "react-router";
import { useMe } from "../shared/api/session";
import { ScreenSkeleton } from "../shared/skeleton/ScreenSkeleton";
import { choicesOf, portalPath, storedChoice } from "../shared/workspace";

/** "/" decides where each person goes: login, welcome, setup, waiting for validation, their portal or the picker. */
export function RootRedirect() {
  const me = useMe();
  if (me.isPending) return <ScreenSkeleton />;
  if (me.isError) return <ScreenSkeleton error onRetry={() => void me.refetch()} />;
  if (!me.data) return <Navigate to="/login" replace />;

  const workspaces = me.data.workspaces;
  if (workspaces.length === 0) return <Navigate to="/welcome" replace />;
  // The owner of a company still in setup goes back to the step where they stopped.
  if (workspaces.some((w) => w.tenantStatus === "configuring" && w.roles.includes("owner"))) return <Navigate to="/onboarding" replace />;

  const choices = choicesOf(me.data);
  // Accepted a clinical invite but not validated yet, and nothing else to open.
  if (choices.length === 0) return <Navigate to="/pending" replace />;
  if (choices.length === 1) return <Navigate to={portalPath((choices[0] as (typeof choices)[number]).portal)} replace />;
  // Several companies or portals (W29): reopen the last one, or ask.
  const last = storedChoice(me.data);
  return <Navigate to={last ? portalPath(last.portal) : "/select-workspace"} replace />;
}
